"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _uuid = _interopRequireDefault(require("uuid"));

var _emotionTheming = require("emotion-theming");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _Snackbar = _interopRequireDefault(require("../Snackbar"));

var _DarkSnackbar = _interopRequireDefault(require("../DarkSnackbar"));

var _UploadBar = _interopRequireDefault(require("../UploadBar/"));

var _Notification = _interopRequireDefault(require("../Notification"));

var _SnackbarWrapper = _interopRequireDefault(require("./SnackbarWrapper.style"));

var ShowSnackbar =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(ShowSnackbar, _PureComponent);

  function ShowSnackbar() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, ShowSnackbar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(ShowSnackbar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "state", {
      snackbars: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "cancel", function (id) {
      var snackbar = _this.state.snackbars.find(function (s) {
        return s.id === id;
      });

      snackbar.onCancel && snackbar.onCancel(id);

      _this.remove(id);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "remove", function (removeId) {
      _this.setState(function (_ref) {
        var snackbars = _ref.snackbars;
        return {
          snackbars: snackbars.map(function (snackbar) {
            if (snackbar.id !== removeId) return snackbar;
            snackbar.onCancel && snackbar.onCancel(removeId);
            return (0, _objectSpread2.default)({}, snackbar, {
              remove: true
            });
          })
        };
      });

      setTimeout(function () {
        return _this.removeAfterAnimation(removeId);
      }, 240);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "removeAfterAnimation", function (removeId) {
      _this.setState(function (_ref2) {
        var snackbars = _ref2.snackbars;
        return {
          snackbars: snackbars.filter(function (_ref3) {
            var id = _ref3.id;
            return id !== removeId;
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "showSnackbar", function (snackbar) {
      var id = (0, _uuid.default)();

      _this.setState(function (_ref4) {
        var snackbars = _ref4.snackbars;
        return {
          snackbars: [(0, _objectSpread2.default)({}, snackbar, {
            id: id
          })].concat((0, _toConsumableArray2.default)(snackbars))
        };
      });

      var _snackbar$duration = snackbar.duration,
          duration = _snackbar$duration === void 0 ? 3 : _snackbar$duration,
          type = snackbar.type;

      if (duration !== -1 && type !== 'upload') {
        setTimeout(function () {
          return _this.remove(id);
        }, duration * 1000);
      }

      return id;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "changeSnackbar", function (id, changedSnackbar) {
      _this.setState(function (_ref5) {
        var snackbars = _ref5.snackbars;
        return {
          snackbars: snackbars.map(function (snackbar) {
            return snackbar.id === id ? (0, _objectSpread2.default)({}, snackbar, changedSnackbar) : snackbar;
          })
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getSnackBar", function (darkTheme) {
      return darkTheme ? _DarkSnackbar.default : _Snackbar.default;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "getBarComponent", function (type, darkTheme) {
      switch (type) {
        case 'upload':
          return _UploadBar.default;

        case 'notification':
          return _Notification.default;

        default:
          return _this.getSnackBar(darkTheme);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderSnackBar", function (item) {
      var Bar = _this.getBarComponent(item.type, item.darkTheme);

      return _react.default.createElement(Bar, (0, _extends2.default)({}, item, {
        onClose: _this.remove,
        onCancel: _this.cancel,
        key: item.id
      }));
    });
    return _this;
  }

  (0, _createClass2.default)(ShowSnackbar, [{
    key: "render",
    value: function render() {
      var snackbars = this.state.snackbars;
      var snackbarList = snackbars.filter(function (item) {
        return item.type !== 'upload' && item.type !== 'notification' && !item.darkTheme;
      });
      var darkSnackbarList = snackbars.filter(function (item) {
        return item.type !== 'upload' && item.type !== 'notification' && item.darkTheme;
      });
      var nonSnackbar = snackbars.filter(function (item) {
        return item.type === 'upload' || item.type === 'notification';
      });
      return _react.default.createElement(_emotionTheming.ThemeProvider, {
        theme: _themeConfig.default
      }, _react.default.createElement("div", null, _react.default.createElement(_SnackbarWrapper.default, {
        type: "top"
      }, snackbarList.map(this.renderSnackBar), darkSnackbarList.map(this.renderSnackBar)), _react.default.createElement(_SnackbarWrapper.default, null, nonSnackbar.map(this.renderSnackBar))));
    }
  }]);
  return ShowSnackbar;
}(_react.PureComponent);

var _default = ShowSnackbar;
exports.default = _default;